export default "__VITE_ASSET__CwDlKIoj__"